import React, { useState } from 'react'
import Countup from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'
import Carousel from '../components/Carousel'
import { Typography, Divider, Grid, Stack, Container, Link } from '@mui/material'
import { Helmet } from "react-helmet-async";

const About = () => {

  const [counterOn, setCounterOn] = useState(false)
  const frontend = 'https://oureclecticsociety.com/'

  return (
    <div>

      <Helmet>
        <title>OES | About</title>
        <meta property="og:title" content="Our Eclectic Society" />
        <meta property="og:description" content="Mindful thoughts and discussions about our continent" />
        <meta property="og:image" content="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBCx9vFl53HaCEXmR8GEAt17HSkg4haraDNw&s" />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />
        <meta name="description" content="Learn more about OurEclecticSociety" />
        <meta
          name="keywords"
          content="African, Nairobi, Growth, Economy, Culture, History, Politics, Society, Eclectic"
        />
        
        <link rel="canonical" href="/about" />
      </Helmet>

      <Carousel />

      <Divider sx={{ my: 3 }}/>
      <Container sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} sx={{ my: 5}}>
          <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
            <Typography variant="h6">Afrocentric</Typography>
            <b>
            <Typography variant="h4">
              Mindful Conversations Create the Changes We Wish to See!
            </Typography></b>
          </Grid>
          <Grid item xs={12} md={8} /*sx={{ textAlign: 'center' }}*/>
            <Typography align = "justify" variant="subtitle1" sx={{ my: 2}}>
              Our current eclectic society is an afrocentric platform 
              that highlights and gives room for discussion on matters
              that influence us under the umbrellas of Economics,
              Politics and Culture.
            </Typography>
            <Typography align = "justify" variant="subtitle1" >
              In Our Eclectic Society, we have a lot to learn
              and unlearn to facilitate self development, awareness
              and by extension responsibility to develop our environment.
            </Typography>
            <Divider sx={{ my: 3 }}/>
            <i>Our Essence is to Navigate a Path to Better and Healthier Lives</i>
          </Grid>
        </Grid>
      

        <Divider sx={{ my: 3 }}/>

        <Grid container spacing={2} sx={{ my: 5}}>

          <Grid item xs={6} md={3}>
            <Typography variant="h4"> Some Cool Facts About Africa</Typography>
            <Typography variant="subtitle1" sx={{ mt: 2 }}>Numbers Speak For Themselves</Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Stack sx={{ textAlign: 'center' }}>
              <ScrollTrigger onEnter={()=>setCounterOn(true)} onExit={()=>setCounterOn(false)}>
                <Typography color={'orange'} variant="h2" sx={{ ml: 6 }}>
                  {counterOn && <Countup
                    start={0}
                    end={54}
                    duration={4}
                    delay={0}
                    
                  />}
                </Typography>
              </ScrollTrigger>
              <Typography sx={{ paddingLeft: 3 }} variant="h6">Countries</Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} md={3}>
            <Stack>
              <Typography color={'green'} variant="h2"> 1.5 B</Typography>
              <Typography variant="h6">People call it home</Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} md={3}>
            <Stack>
              <Typography color={'red'} variant="h2"> 2nd</Typography>
              <Typography variant="h6">Largest Continent</Typography>
            </Stack>
          </Grid>

        </Grid>

        <Divider sx={{ my: 3 }}/>

        <Typography className='welcome' variant="h3" sx={{ my: 3}}>ADULTING IN AN ECLECTIC SOCIETY</Typography>

        <Grid container spacing={4} sx={{ mt: 3, mb: 3, px:3}}>
          <Grid xs={12} md={4}>
            <Typography className='edo' variant="h4" sx={{pb: 3}}>This World We Live In</Typography>
            <Typography align="justify" variant="subtitle1" sx={{paddingRight: 2}}>
              We are now interacting and consuming more information, experiences,
              food and culture, even traumas- like it's a buffet. Read
              <Link href= {`${frontend}/article/2}`} underline='hover'> more..</Link>
            </Typography>
          </Grid>
          <Grid xs={12} md={4}>
            <Typography className='edo' variant="h4" sx={{pb: 3}}>Change</Typography>
            <Typography align="justify" variant="subtitle1" sx={{paddingRight: 2}}>
              Mindful Conversations Can Create 
              the Changes We Wish To See.
              Suspendisse congue dui et 
              vestibulum sodales. Maecenas lacus
              quam, tincidunt eu porta vitae, 
              pellentesque vel justo
            </Typography>
          </Grid>
          <Grid xs={12} md={4}>
            <Typography className='edo' variant="h4" sx={{pb: 3}}>Leaders of Today</Typography>
            <Typography align="justify" variant="subtitle1">
              Suspendisse congue dui et 
              vestibulum sodales. Maecenas 
              lacusquam, tincidunt eu porta
              pellentesque vel justoplacerat
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default About
